import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

// "27 Oct 13:52 UTC"; null for missing or invalid input.
export function formatUtcShort(ts) {
  if (!ts) return null
  const d = dayjs.utc(ts)
  return d.isValid() ? `${d.format("DD MMM HH:mm")} UTC` : null
}

export function formatUpdatedUtc(ts) {
  const text = formatUtcShort(ts)
  return text ? `Updated ${text}` : null
}

// Last calculation of a route; the row timestamp for routes without summary.calculated_at.
export const routeUpdatedAt = (route) => route?.summary?.calculated_at ?? route?.timestamp ?? null
